/* istanbul ignore next */
const ACTIONS = {
    FETCH_BASE_PAGE_DATA_SUCCESS: 'FETCH_BASE_PAGE_DATA_SUCCESS',
    FETCH_BASE_PAGE_DATA_ERROR: 'FETCH_BASE_PAGE_DATA_ERROR',

    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',
    UPDATE_TRIP_DATA: 'UPDATE_TRIP_DATA',
    INIT_TRIP_DATA: 'INIT_TRIP_DATA'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchBasePageDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_BASE_PAGE_DATA_SUCCESS,
            payload: {
                response
            }
        };
    },

    fetchBasePageDataError(response) {
        return {
            type: ACTIONS.FETCH_BASE_PAGE_DATA_ERROR,
            payload: {
                response
            }
        };
    },

    triggerEdapPageView() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW
        };
    },

    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options
            }
        };
    },

    updateTripData(tripData) {
        return {
            type: ACTIONS.UPDATE_TRIP_DATA,
            payload: tripData
        };
    },

    initTripData(tripData) {
        return {
            type: ACTIONS.INIT_TRIP_DATA,
            payload: tripData
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/actions/actions.js